import { LanguageBasicInfo } from "./LanguageBasicInfo";
import { GroupStoreInfo } from "./UserGroupStoreAccess";

export interface User {
    username: string;
    firstname: string;
    lastname: string;
}

export interface UserSummary extends User {
    language: LanguageBasicInfo[];
    activeGroupStore: GroupStoreInfo;
}

export function getUserInitials(user: User): string {
    const firstInitial = user.firstname.charAt(0).toUpperCase();
    const lastInitial = user.lastname.charAt(0).toUpperCase();

    return `${firstInitial}${lastInitial}`;
}